module.exports = __webpack_public_path__ + "assets/img/portfolio-details.44f75f80.png";